import React from 'react'
import { storiesOf } from '@storybook/react'
import { withKnobs, number, select } from '@storybook/addon-knobs/react'

import { MatchStatus } from 'protos'
import GameCardProgressBar, { GameCardClassicProgressBar } from 'components/GameCard/components/GameCardProgressBar'

storiesOf('GameCard/GameCardProgressBar', module)
  .addDecorator(withKnobs)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#DDD' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#DDD', width: 320, borderTop: '1px solid white' }}>{story()}</div>
    </>
  ))
  .add('default (with knobs)', () => (
    <GameCardProgressBar
      variant={select('variant:', { match: 'match', invite: 'invite' }, 'match')}
      value={number('value:', 58)}
      max={number('max:', 120)}
    />
  ))
  .add('classic (with knobs)', () => (
    <GameCardClassicProgressBar
      max={number('max:', 120)}
      values={[{
        status: MatchStatus.MS_FINISHED,
        progress: number('finished:', 25),
      }, {
        status: MatchStatus.MS_LIVE,
        progress: number('live:', 35),
      }, {
        status: MatchStatus.MS_UPCOMING,
        progress: number('upcoming:', 50),
      }]}
    />
  ))
